import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'cedente' },
  {
    path: 'comprador',
    loadChildren: () =>
      import('./modules/buyer.module').then((m) => m.BuyerModule),
  },
  {
    path: 'broker',
    loadChildren: () =>
      import('./modules/buyer.module').then((m) => m.BuyerModule),
  },
  {
    path: 'cedente',
    loadChildren: () =>
      import('./modules/supplier.module').then((m) => m.SupplierModule),
  },
  { path: '**', redirectTo: 'cedente' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
